export const PAYMENT_METHOD_TYPE_UNSPECIFIED = 'BALANCE_INVOICE_PAYMENT_METHOD_TYPE_UNSPECIFIED';
export const PAYMENT_METHOD_TYPE_MUTANT = 'BALANCE_INVOICE_PAYMENT_METHOD_TYPE_MUTANT';
export const PAYMENT_METHOD_TYPE_WALLET = 'BALANCE_INVOICE_PAYMENT_METHOD_TYPE_WALLET';
export const PAYMENT_METHOD_TYPE_VJI_WALLET = 'BALANCE_INVOICE_PAYMENT_METHOD_TYPE_VJI_WALLET';
export const MITRA_REFERRAL_PRODUCT_TYPE = 'mitra-referral';

export const PAYMENT_METHOD_NAME = {
  [PAYMENT_METHOD_TYPE_MUTANT]: 'Saldo DANA',
  [PAYMENT_METHOD_TYPE_WALLET]: 'Saldo Mitra',
  [PAYMENT_METHOD_TYPE_VJI_WALLET]: 'BukaPay',
};

export const BALANCE_STATE_ACTIVE = 'active';
export const BALANCE_STATE_INACTIVE = 'inactive';
export const BALANCE_STATE_FROZEN = 'frozen';
export const BALANCE_STATE_ERROR = 'error';

export const DANA_CODE_INACTIVE = 20201;
export const DANA_CODE_FROZEN = 20207;

export const BUKA20_TRANSACTION_TYPES = 'buka20-transactions';
export const MITRA_BANTUAN_TRANSACTION_TYPES = [
  'topup',
  'digital-send',
  'withdrawal',
  'qris',
  'qris-cash-out',
  'edc-cashout',
  'mitra-item-edc',
  'mitra-item-qris-soundbox',
  'prepaid-electricity',
  'prepaid-phone-topup',
  'prepaid-phone-plan',
  'e-wallet',
  'postpaid-electricity',
  'game-voucher',
  'in-game-topup',
  'water-bill',
  'e-money',
  'cable-tv',
  'e-wallet-open-amount',
  'credit-card-bill',
  'prepaid-phone-transfer',
  'remittance',
  'tax-property-bill',
  'multifinance',
  'prepaid-cable-tv',
  'gas-bill',
  'social-health-insurance',
  'telkom-bill',
  'phone-bill',
  'multilane-free-flow',
  'social-employment-insurance',
  'regional-tax',
  'non-gas-bill',
  'prepaid-phone-plan-voucher',
  'prepaid-phone-activation-voucher',
  'prepaid-phone-e-sim',
  'government-revenue',
  'mitra-referral',
  'e-meterai',
  'mitra-subscription',
  'prepaid-phone-physical-voucher',
  'education',
  'travel',
];

export const BILLING_PAYMENT_TYPES_MAPPING = {
  [PAYMENT_METHOD_TYPE_MUTANT]: 'BILLING_PAYMENT_METHOD_MUTANT',
  [PAYMENT_METHOD_TYPE_WALLET]: 'BILLING_PAYMENT_METHOD_WALLET',
  [PAYMENT_METHOD_TYPE_VJI_WALLET]: 'BILLING_PAYMENT_METHOD_VJI_WALLET',
};

export const BILLING_PRODUCT_TYPES = {
  'prepaid-phone': 'prepaid-phone',
  'e-wallet': 'e-wallet',
  'cable-tv': 'cable-tv',
  'education': 'education',
};

// value follow the apps config 'mitra-payment-method-config'
// ref: https://gitlab.cloud.bukalapak.io/apps/mitra_bukalapak_android/-/merge_requests/236
export const NEO_CONFIG_PAYMENT_CODE_MAPPING = {
  wallet: PAYMENT_METHOD_TYPE_WALLET,
  dana: PAYMENT_METHOD_TYPE_MUTANT,
  vji_wallet: PAYMENT_METHOD_TYPE_VJI_WALLET,
};

export const MITRA_SUBSCRIPTION_TRANSACTION_TYPE = 'mitra-subscription';
export const MITRA_REFERRAL_TRANSACTION_TYPE = 'mitra-referral';
